// extracted by mini-css-extract-plugin
module.exports = {"section":"DiscountRowSection_section__4iS6I","view_all":"DiscountRowSection_view_all__KsaKF"};